import classNames from 'classnames';

export default function LevelRight(props: {
    children?: any,
    className?: string,
    onClick?: () => void
}) {
    let className = props.className ?? '';

    const classes = classNames('level-right', {
        [className]: className.length
    });

    return (
        <div className={classes} onClick={props.onClick}>
            {props.children}
        </div>
    );
}
